import { Brand } from '@blade/std-lib'

export const SupportTicketMessageIdTypeId =
  'tradebot-tma/SupportTicketMessageId'
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type SupportTicketMessageIdTypeId = typeof SupportTicketMessageIdTypeId

export type SupportTicketMessageId = Brand.Branded<
  string,
  SupportTicketMessageIdTypeId
>
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupportTicketMessageId = Brand.nominal<SupportTicketMessageId>()
